module.exports = __webpack_public_path__ + "img/tableImg.8ce381b0.jpg";